import { useIntl } from 'react-intl';

import { TourListCard } from './TourListCard.tsx';

export const ChargingStopCard = ({
    name,
    duration,
    arrivalCharge,
    targetCharge,
    batteryCapacity,
    leadingWidth = 70,
}: {
    name?: string;
    duration: number;
    arrivalCharge: number;
    targetCharge: number;
    batteryCapacity: number;
    leadingWidth?: 70 | 80;
}) => {
    const intl = useIntl();
    const label = intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.routing-settings.charging' });
    return (
        <TourListCard
            leadingWidth={leadingWidth}
            shadow
            testId='charging-stop-card'
            leading={
                <div className='display-flex flex-column align-items-center gap-2'>
                    <span
                        className='uikit-icon icon-battery-charging text-size-20 text-color-darker'
                        aria-hidden='true'
                    />
                    <span className='text-size-12'>{label}</span>
                </div>
            }
        >
            <div className='display-flex justify-content-between gap-10'>
                <strong>{name || label}</strong>
            </div>
            {Number.isFinite(batteryCapacity) && batteryCapacity > 0 && (
                <div className='margin-top-5'>
                    {intl.formatMessage(
                        { id: 'intl-msg:ordercom-cloud-frontend.routing-settings.chargeLevels' },
                        {
                            arrival: Math.round((arrivalCharge / batteryCapacity) * 100),
                            departure: Math.round((targetCharge / batteryCapacity) * 100),
                        }
                    )}
                </div>
            )}
            <div className='alert alert-success margin-top-10 margin-bottom-0 display-flex justify-content-between gap-10'>
                <span>
                    {intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.routing-settings.chargingTime' })}
                </span>
                <strong>{Math.ceil(duration / 60)} min</strong>
            </div>
        </TourListCard>
    );
};
